<template>
  <div>
    <div class="form form_w660 form_pa30 form_m_pa16">
      <div class="form-item form-item_flex form-item_between mb16">
        <div class="form-item_auto mb24_m mr24">
          <label class="upload-image" for="upload-image">
            <input class="upload-image__input" type="file" id="upload-image" @change="uploadImage" />
            <span
              class="upload-image__span"
              :style="{
                backgroundImage: `url(${clientImage.url})`,
              }"
            ></span>

            <span class="upload-image__replace" v-if="isUploadedImage">
              <img src="/images/greyCamera.png" alt />
            </span>
          </label>
        </div>

        <div class="form-item_w100 mb24_m">
          <el-input
            class="mb22"
            :placeholder="$t('forms.firstName')"
            type="text"
            v-model="form.first_name"
            autocomplete="off"
            @change="logChanges('profile_firstLastName_changed')"
          ></el-input>

          <el-input
            :placeholder="$t('forms.lastName')"
            type="text"
            v-model="form.last_name"
            autocomplete="off"
            @change="logChanges('profile_firstLastName_changed')"
          ></el-input>
        </div>
      </div>

      <div class="form-item form-item_flex form-item_between flex-m-column">
        <div class="form-item_half mb24_m">
          <el-input
            :placeholder="$t('forms.email')"
            type="text"
            v-model="form.email"
            autocomplete="off"
            @change="logChanges('profile_email_changed')"
          ></el-input>

          <button
            class="mt12 form-item__confirmation foz12"
            @click="sendEmail"
            v-if="!client.confirmed || isSendEmail"
          >resend confirmation email</button>
        </div>

        <div class="form-item_half">
          <vue-tel-input
            defaultCountry="at"
            v-model="form.phone"
            @validate="checkValue"
            :placeholder="$t('forms.phone')"
            :inputOptions="{ showDialCode: true }"
            mode="international"
            :ref="'vue-tel-ref'"
            disabled
          ></vue-tel-input>
        </div>
      </div>

      <app-billing-address
        :billingAdddressString="billingAdddressString"
        @openBillingModal="openBillingModal"
      />

      <app-addresses />

      <div class="form-item">
        <button
          @click="save"
          class="btn btn_mt-10 btn_width btn_mobile-width-100"
          :disabled="!isValid"
          :class="{
            btn_disabled: !isValid,
          }"
        >{{ $t("buttons.save") }}</button>
      </div>
    </div>
    <div class="form-item mt12 ml20">
      <a
        href="#"
        class="form-item__delete-account"
        @click="toggleDeleteModal"
      >{{ $t("forms.deleteText") }}</a>
    </div>

    <main-modal :show="showDeleteModal" :className="'delete-modal'" @close="toggleDeleteModal">
      <delete-modal @close="toggleDeleteModal" @accept="removeAccount" />
    </main-modal>

    <main-modal :show="isOpenBillingModal" :className="'address-modal'" @close="closeBillingModal">
      <add-billing-address @close="closeBillingModal" @done="saveBillingAddress" />
    </main-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

import checkEmail from "@/helpers/utils/emailCheck";
import mainModal from "@/components/modals/mainModal";
import deleteModal from "@/components/modals/delete/index";
import appAddresses from "@/components/base/addresses/appAddresses";
import appBillingAddress from "@/components/base/addresses/appBillingAddress";

import addBillingAddress from "@/components/modals/address/addBillingAddress";

import {
  required,
  email,
  requiredIf,
  minLength,
  sameAs
} from "vuelidate/lib/validators";

export default {
  name: "edit-profle",
  components: {
    appAddresses,
    mainModal,
    deleteModal,
    addBillingAddress,
    appBillingAddress
  },
  data() {
    return {
      isValidPhone: false,
      showDeleteModal: false,
      isSendEmail: false,
      clientImage: {
        url: "/images/Big.png",
        file: null
      },
      isOpenBillingModal: false
    };
  },
  computed: {
    ...mapGetters({
      client: "client/client",
      form: "client/form",
      isUpdate: "address/isUpdate",
      addressesCount: "address/count",
      addresses: "address/addresses",
      billingAdddressString: "address/billingAdddressString"
    }),
    isValid() {
      return !this.$v.$invalid && this.isValidPhone;
    },
    isUploadedImage() {
      return this.clientImage.url !== "/images/Big.png";
    }
  },
  validations: {
    form: {
      first_name: {
        required
      },
      last_name: {
        required
      },
      email: {
        required,
        email
      },
      phone: {
        required
      }
    }
  },
  methods: {
    ...mapMutations({
      setClientForm: "client/setClientForm",
      setAddressState: "address/setState"
    }),
    ...mapActions({
      saveClient: "client/save",
      deleteAccount: "client/deleteAccount",
      saveImage: "client/saveImage",
      confirmEmail: "public/confirmEmail",
      fetchBillingAddress: "address/fetchBillingAddress",
      createBillingAddress: "address/addBillingAddress"
    }),
    async saveBillingAddress() {
      const response = await this.createBillingAddress();
      const isOkey = response.status === 200 || response.status === 201;

      if (!isOkey) return;

      await this.fetchBillingAddress();
      this.closeBillingModal();
    },
    closeBillingModal() {
      this.isOpenBillingModal = false;
    },
    openBillingModal() {
      if (!this.billingAdddressString) {
        this.setAddressState({
          key: "billingAddress",
          value: {
            country: null,
            city: null,
            street: null,
            house: null,
            first_name: this.client.first_name,
            last_name: this.client.last_name,
            postcode: null,
            greetings: null
          }
        });
      }

      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });

      this.isOpenBillingModal = true;
    },
    prepareFormData() {
      const phone = this.form.phone.replace(/\s+/g, "");

      return {
        ...this.form,
        phone
      };
    },
    prepareImageFormData() {
      const fd = new FormData();
      fd.append("image", this.clientImage.file);

      return fd;
    },
    toggleResendBtn() {
      this.isSendEmail = true;
    },
    async sendEmail() {
      this.toggleResendBtn();
      const response = await this.confirmEmail();
      this.handleResponse(response);
    },
    handleResponse(response) {
      if (response.status == 200) {
        this.$notify({
          title: this.$t("notifications.emailSent"),
          message: this.$t("notifications.emailSentText"),
          duration: 5000
        });
      }
    },
    async save() {
      if (!this.isValid) {
        return;
      }

      const response = await this.saveClient(this.prepareFormData());
      this.notify(response);

      if (this.clientImage.file) {
        await this.saveImage(this.prepareImageFormData());
      }
    },
    notify({ status, data }) {
      if (status == 200 || status == 201) {
        this.$notify({
          title: this.$t("notifications.profileUpdated"),
          message: this.$t("notifications.profileUpdatedText"),
          duration: 5000
        });
      } else if (status == 422) {
        this.$notify({
          title: this.$t("alerts.warning"),
          message: data.fields[0].message,
          duration: 5000
        });
      }
    },
    setClientImage(image) {
      this.clientImage.url = image;
    },
    setClientImageFile(file) {
      this.clientImage.file = file;
    },
    setForm() {
      this.setClientForm({
        first_name: this.client.first_name,
        last_name: this.client.last_name,
        phone: this.client.phone,
        email: this.client.email
      });

      if (this.client.big_image) {
        this.setClientImage(this.client.big_image);
      }
    },
    checkValue(v) {
      this.isValidPhone = v.valid && v.type == "mobile";
    },
    async removeAccount() {
      this.toggleDeleteModal();
      await this.deleteAccount();
      this.$log("profile_deleteAccount");
    },
    toggleDeleteModal() {
      this.showDeleteModal = !this.showDeleteModal;
    },
    uploadImage(e) {
      const file = Array.from(e.target.files)[0];

      this.setClientImageFile(file);

      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.addEventListener("load", () => {
        this.setClientImage(reader.result);
      });
    },
    logChanges(event) {
      this.$log(event);
    }
  },
  beforeMount() {
    this.setForm();
    this.fetchBillingAddress();
    this.$log("profile_firstLastName");
    this.$log("profile_email");
  }
};
</script>
